// export const API_URL = process.env.API_URL || "http://localhost:5000";
export const API_URL = process.env.API_URL || "https://ghnk-crm-server.herokuapp.com";